import React from "react";
import { Row, Col, Badge, Tooltip } from "antd";

const BookingStatusWidget = () => {
  const statusData = [
    {
      status: "0",
      label: "Pending",
      color: "#ff9800",
    },
    {
      status: "1",
      label: "Ongoing",
      color: "#4caf50",
    },
    {
      status: "2",
      label: "Completed",
      color: "#2196f3",
    },
    {
      status: "3",
      label: "Canceled",
      color: "#f44336",
    },
    {
      status: "4",
      label: "Accepted",
      color: "#faad14",
    },
  ];

  return (
    <Row gutter={16}>
      {statusData.map((statusItem) => (
        <Col span={3} key={statusItem.status}>
          <div className="status-item">
            <Tooltip title={statusItem.label}>
              <Badge
                color={statusItem.color}
                text={statusItem.label}
                style={{
                  backgroundColor: "transparent",
                  fontSize: "16px",
                  width: "100%",
                  textAlign: "center",
                  padding: "10px",
                }}
              />
            </Tooltip>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default BookingStatusWidget;
